const theme = {
	primary: {
		lightest: '#F2EEFF',
		lighter: '#B9A3F6',
		light: '#7F59E8',
		normal: '#5F30E2',
		dark: '#351490',
		darker: '#230D60',
		darkest: '#120730'
	},
	gray: {
		lightest: '#FBFBFB',
		lighter: '#D5D5D5',
		light: '#BBBBBB',
		normal: '#8E8E95',
		dark: '#6A6A70',
		darker: '#46464B',
		darkest: '#343234'
	}
};

export default theme;
